"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DidStore = void 0;
/* eslint-disable no-restricted-syntax */
const ipfs_http_client_1 = __importDefault(require("ipfs-http-client"));
const bl_1 = __importDefault(require("bl"));
class DidStore {
    /**
     * @param uri {string} - IPFS API server uri
     */
    constructor(uri) {
        this.ipfs = (0, ipfs_http_client_1.default)(uri);
    }
    save(claim) {
        var e_1, _a;
        return __awaiter(this, void 0, void 0, function* () {
            const asyncChunks = yield this.ipfs.add(claim);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let cid;
            try {
                for (var asyncChunks_1 = __asyncValues(asyncChunks), asyncChunks_1_1; asyncChunks_1_1 = yield asyncChunks_1.next(), !asyncChunks_1_1.done;) {
                    const chunk = asyncChunks_1_1.value;
                    cid = chunk.cid; // return cid from last (and only one) chunk
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (asyncChunks_1_1 && !asyncChunks_1_1.done && (_a = asyncChunks_1.return)) yield _a.call(asyncChunks_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return cid.toString();
        });
    }
    /**
     * @param uri {string} CID of the file with claim content
     */
    get(uri) {
        var e_2, _a, e_3, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let claim = '';
            try {
                for (var _c = __asyncValues(this.ipfs.get(`/ipfs/${uri}`)), _d; _d = yield _c.next(), !_d.done;) {
                    const file = _d.value;
                    const content = new bl_1.default();
                    try {
                        for (var _e = (e_3 = void 0, __asyncValues(file.content)), _f; _f = yield _e.next(), !_f.done;) {
                            const chunk = _f.value;
                            content.append(chunk);
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) yield _b.call(_e);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    claim += content.toString();
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) yield _a.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return claim;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    delete(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Not supported by IPFS');
        });
    }
}
exports.DidStore = DidStore;
//# sourceMappingURL=didStore.js.map